<dashboardnav>

    <main class="main_content">

        

        <div class="display_selection" >
            <div class="the_card">
              <div class="top_title">
                <h2 class="title">Quick links</h2>
                <em class="ti-close"></em> 
              </div>


               
              <h2 class="item">
                <span class="name">Principles of Macro Economics</span>
                <span class="description">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Facilis, deserunt!</span>
              </h2>
              <h2 class="item">
                <span class="name">Principles of Macro Economics</span>
                <span class="description">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Facilis, deserunt!</span>
              </h2>
              <h2 class="item">
                <span class="name">Principles of Macro Economics</span>
                <span class="description">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Facilis, deserunt!</span>
              </h2>
    
              <span class="check_default">
                <input type="checkbox" name="" id="" />
                Set as default
              </span>
            </div>
          </div>
    </main>

   

</dashboardnav>




<!-- <div>Dashboard is Working</div> -->